import React, { useEffect, useState } from "react";
import adviser from "../../assets/members/president.jpeg";
import api from "../../utils/axios.config";
import logo from "../../assets/image/logo.png";
import { MessageSquareQuote, User, Loader2 } from "lucide-react";
import useLogo from "../../hooks/useLogo";

const PresidentMessage = () => {
  const [message, setMessage] = useState([]);
  const [loading, setLoading] = useState(true);
  const { data: logoUrl } = useLogo();

  const handleGetMessage = async () => {
    try {
      setLoading(true);
      const { data } = await api.get("president-message");
      setMessage(data.presidentMessage);
    } catch (error) {
      console.error("Failed to fetch president message:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetMessage();
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 mt-20 py-8 bg-gradient-to-b from-primary/5 to-white">
      {/* Header with decorative elements */}
      <div className="text-center mb-8">
        <h1 className="relative inline-block text-3xl md:text-4xl font-bold text-primary mb-2">
          <span className="absolute -left-8 top-1/2 transform -translate-y-1/2 hidden md:block">
            <MessageSquareQuote className="h-6 w-6 text-primary/70" />
          </span>
          কেন্দ্রীয় সভাপতির বাণী
          <span className="absolute -right-8 top-1/2 transform -translate-y-1/2 hidden md:block">
            <MessageSquareQuote className="h-6 w-6 text-primary/70 transform rotate-180" />
          </span>
        </h1>
        <div className="h-1 w-24 bg-primary mx-auto rounded-full"></div>
      </div>

      {/* Card Container */}
      <div className="flex flex-col md:flex-row gap-8 items-stretch">
        {/* Profile Card */}
        <div className="flex-1 bg-white rounded-lg shadow-lg overflow-hidden flex flex-col">
          <div className="bg-primary py-4 px-6 text-center">
            <h2 className="text-xl font-semibold text-white flex items-center justify-center">
              <User className="mr-2 h-5 w-5" />
              কেন্দ্রীয় সভাপতি
            </h2>
          </div>

          <div className="p-6 text-center flex-grow">
            <div className="mb-4 relative">
              <div className="w-40 h-40 mx-auto rounded-full overflow-hidden border-4 border-primary/10 shadow-md">
                <img
                  src={adviser}
                  alt="President"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-800 mb-1">
              প্রকৌ. ক্লিনটন আচার্য্য
            </h3>

            <p className="font-bold text-center">
              <span className="text-sm">প্রভাষক(আইসিটি)</span>
            </p>
            <p className="font-bold text-center">সভাপতি, কেন্দ্রীয় কমিটি</p>
            <p className="font-bold text-center">নিঃস্বার্থ নবজীবন সংগঠন</p>
          </div>
        </div>

        {/* Message Card */}
        <div className="flex-1 bg-white rounded-lg shadow-lg overflow-hidden flex flex-col">
          <div className="bg-primary py-4 px-6">
            <h2 className="text-xl font-semibold text-white flex items-center">
              <MessageSquareQuote className="mr-2 h-5 w-5" />
              কেন্দ্রীয় সভাপতির বাণী
            </h2>
          </div>

          <div className="p-6 flex-grow">
            {loading ? (
              <div className="flex items-center justify-center h-full">
                <Loader2 className="h-8 w-8 text-primary animate-spin" />
              </div>
            ) : (
              <div className="prose max-w-none text-gray-700 leading-relaxed">
                <img
                  width={100}
                  height={100}
                  className="float-left px-2"
                  src={logoUrl || "/logo.png"}
                  alt="Logo"
                />
                {message && message[message?.length - 1]?.message}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PresidentMessage;
